<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('inscriptions')"
      :columns="columns"
      :column_search="true"
      :extra_data="{ student_uuid: $route.params.uuid }"
      resource_url="/student/inscription/datatables"
      :is_container="false"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
    <!-- <div class="is-divider"></div>
    <div class="timeline">
      <header class="timeline-header">
        <div class="field is-grouped is-grouped-multiline">
          <div class="control">
            <div class="tags has-addons">
              <a class="tag is-medium is-primary">{{ $t("appointments") }}</a>
              <a class="tag is-medium"
                ><span class="icon has-text-primary" @click="refresh">
                  <i class="fa fa-refresh"></i> </span
              ></a>
            </div>
          </div>
        </div>
      </header>
      <div
        class="timeline-item pb-0"
        v-for="(appointment, aidx) in appointments"
        :key="aidx"
      >
        <div class="timeline-marker"></div>
        <div class="timeline-content">
          <p class="heading">{{ format_date_time(appointment.start_date) }}</p>
          <div class="subtitle is-6" v-if="appointment.doctor_team_member">
            {{ appointment.doctor_team_member.name }}
          </div>
        </div>
      </div>
    </div> -->
    <!-- <appointment-modal ref="appointment_modal" @success="refresh" /> -->
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
// import AppointmentModal from "../../appointment_modal/Index.vue";
import {
  get,
  error_message,
  format_date_time,
  format_date,
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
} from "@/utils";

export default {
  name: "Inscriptions",
  components: { GenericTable },
  data() {
    let v = this;
    return {
      appointments: [],
      columns: [
        {
          title: v.$t("date"),
          searchable: false,
          data: (row) => {
            return format_date(row.create_date);
          },
        },
        {
          title: v.$t("program"),
          searchable: false,
          data: (row) => {
            return row.program ? row.program.name : "";
          },
        },
        // {
        //   title: v.$t("patient"),
        //   searchable: false,
        //   // width: "60%",
        //   data: (row) => {
        //     // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     return row.patient ? row.patient.name : "";
        //   },
        // },
        // {
        //   title: v.$t("doctor"),
        //   searchable: false,
        //   // width: "60%",
        //   data: (row) => {
        //     // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     return row.doctor_team_member ? row.doctor_team_member.name : "";
        //   },
        // },
        // {
        //   title: v.$t("data"),
        //   searchable: false,
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return row.consulting_room ? row.consulting_room.name : "";
        //   },
        // },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              // {
              //   args: { uuid: row.uuid },
              //   tooltip: v.$t("edit"),
              //   icon: "fa fa-edit",
              //   icon_class: "is-small",
              //   click: function (e) {
              //     // console.log("edit order", e.detail.uuid);
              //     v.$refs.appointment_modal.edit_appointment(e.detail.uuid);
              //   },
              // },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete inscription?"),
                    v,
                    () => {
                      del("/student/inscription", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_date,
    refresh() {
      let v = this;
      // Lógica para obtener las citas del paciente
      // get("/patient/appointment/list", { uuid: v.$route.params.patient_uuid })
      //   .then((appointments) => {
      //     v.appointments = appointments;
      //   })
      //   .catch((error) => {
      //     error_message(error);
      // });

      v.$refs.datatable.refresh();
    },
    create() {
      let v = this;
      v.$refs.appointment_modal.create_appointment({
        date: new Date(),
      });
    },
  },
};
</script>

<style scoped>
.container {
  margin-top: 20px;
}
</style>
